import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.videoUrl
    ? _c(
        "div",
        {
          staticClass: "advantage-video",
          class: { "advantage-video--mobile": _setup.isMobile },
          attrs: { "data-qa": "advantage_video" },
        },
        [
          _c("div", {
            staticClass: "advantage-video__glow bg-lpu-branding-color-primary",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "advantage-video__star",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "advantage-video__card rounded-20",
              attrs: { type: "button", "data-qa": "advantage_video_play" },
              on: { click: _setup.handleOpenVideoCard },
            },
            [
              _vm.previewUrl
                ? [
                    _c(VImg, {
                      staticClass: "advantage-video__preview-blur",
                      attrs: { src: _vm.previewUrl, "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c(VImg, {
                      staticClass: "advantage-video__preview",
                      attrs: {
                        src: _vm.previewUrl,
                        alt: _setup.tStatic("Видеовизитка"),
                        contain: "",
                      },
                    }),
                  ]
                : [
                    _c("video", {
                      staticClass: "advantage-video__preview-blur",
                      attrs: {
                        src: _vm.videoUrl,
                        muted: "",
                        playsinline: "",
                        preload: "metadata",
                        "aria-hidden": "true",
                      },
                      domProps: { muted: true },
                    }),
                    _vm._v(" "),
                    _c("video", {
                      staticClass: "advantage-video__preview",
                      attrs: {
                        src: _vm.videoUrl,
                        muted: "",
                        playsinline: "",
                        preload: "metadata",
                      },
                      domProps: { muted: true },
                    }),
                  ],
              _vm._v(" "),
              _c(_setup.VideoCard, {
                ref: "videoCardRef",
                attrs: {
                  "video-url": _vm.videoUrl,
                  "video-uuid": _vm.videoUuid,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "play-button",
                      fn: function () {
                        return [
                          _c(
                            "span",
                            {
                              staticClass:
                                "advantage-video__play-btn branding-btn branding-btn--primary-icon d-inline-flex align-center justify-center rounded-circle",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "ui-icon-player-play advantage-video__play-btn-icon",
                              }),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2305356036
                ),
              }),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }